import { useState, useEffect, useRef } from 'react';

/**
 * Custom hook to track container width using ResizeObserver
 * @param {number} defaultWidth - Default width before measurement (default: 500)
 * @returns {{ containerRef: React.RefObject, containerWidth: number, isMobile: boolean, isCompact: boolean }}
 */
export function useContainerWidth(defaultWidth = 500) {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(defaultWidth);

    useEffect(() => {
        if (!containerRef.current) return;

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setContainerWidth(entry.contentRect.width);
            }
        });

        resizeObserver.observe(containerRef.current);
        setContainerWidth(containerRef.current.offsetWidth || defaultWidth);

        return () => resizeObserver.disconnect();
    }, [defaultWidth]);

    // Derived responsive states
    const isMobile = containerWidth < 500;
    const isCompact = containerWidth < 350;

    return {
        containerRef,
        containerWidth,
        isMobile,
        isCompact,
    };
}

export default useContainerWidth;
